var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBigVector(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 715,
    height: 1409,
    viewBox: "0 0 715 1409",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M715 488.414H0V1409L456.745 948.707L715 688.445V488.414Z",
    fill: "url(#paint0_linear_414_53)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M342.628 345.29L0 690.44V0H685.117L342.628 345.29Z",
    fill: "url(#paint1_linear_414_53)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_414_53",
    x1: -0.0000106543,
    y1: 1409,
    x2: 830.132,
    y2: 1289.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#211D8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F87F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_414_53",
    x1: -0.000010209,
    y1: 690.44,
    x2: 785.393,
    y2: 546.268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#211D8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F87F9"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigVector);
export default __webpack_public_path__ + "static/media/bigVector.fd721e4eceee23bad5b07952c4e19046.svg";
export { ForwardRef as ReactComponent };